import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import {
  trapFocus,
  removeTrapFocus,
} from '@shopify/theme-a11y';

import ScrollLock from '../helpers/ScrollLock';

export default class NavMobileFilters {
  constructor({ controls, mobileNav }) {
    this.controls = controls;
    this.mobileNav = mobileNav;

    if (!this.mobileNav) { return; }

    this.mobileTrigger = this.controls.querySelector('[data-mobile-filters-button]');

    this.closeButton = this.mobileNav.querySelector('[data-mobile-nav-close]');
    this.mainFlyout = this.mobileNav.querySelector('[data-mobile-main-flyout]');
    this.overlay = this.mobileNav.querySelector('[data-mobile-overlay]');

    this.events = new EventHandler();

    this.flyoutAnimation = transition({ el: this.mainFlyout, state: 'closed' });
    this.overlayAnimation = transition({ el: this.overlay, state: 'closed' });

    this.closeEsc = e => {
      if (e.key === 'Escape') {
        this.close();
      }
    };

    this.events.register(this.mobileTrigger, 'click', () => this.open());
    this.events.register(this.closeButton, 'click', () => this.close());
    this.events.register(this.overlay, 'click', () => this.close());
  }

  open() {
    ScrollLock.lock(this.mobileNav);

    this.closeEvent = this.events.register(window, 'keydown', e => this.closeEsc(e));

    this.mobileNav.dataset.open = true;
    this.flyoutAnimation.animateTo('open');
    this.overlayAnimation.animateTo('open');

    this.mobileNav.focus();
    trapFocus(this.mobileNav);
  }

  close() {
    ScrollLock.unlock();

    removeTrapFocus(this.mobileNav);
    this.mobileTrigger.focus();

    this.events.unregister(this.closeEvent);

    this.flyoutAnimation.animateTo('closed');
    this.overlayAnimation.animateTo('closed')
      .then(() => {
        this.mobileNav.dataset.open = false;
      });
  }

  unload() {
    this.flyoutAnimation.animateTo('closed', { force: true });
    this.overlayAnimation.animateTo('closed', { force: true });

    this.flyoutAnimation.unload();
    this.overlayAnimation.unload();
    this.events.unregisterAll();
  }
}
